<template>
  <div class="m_page">
    <!--图片轮播-->
    <div class="swiper-container">
      <div class="swiper-wrapper">
       <div class="swiper-slide" >
         <div class="item_pic_cell">
           <img :src="item.pic" class="item_pic"  />
           <p class="item_text">{{item.detail}}</p>
         </div>
       </div>
   </div>

    </div>
    <!--基本信息-->
    <div class="base_info">
      <p class="item_title_wrapper">
        <strong class="item_title">{{item.goodName}}</strong><span class="item_num"></span>
      </p>
      <p class="item_detail">{{item.comment}}
      </p>
      <div class="exchange_wrapper">
        <div class="exchange_list exchange_bg_orange">
            <div class="exchange_money_wrapper">{{item.score}}券币
                  <div class="circle">
                    <div class="circle1">

                    </div>
                    <div class="circle2">

                    </div>
                  </div>
            </div>
            <div class="exchange_btn_wrapper" @click="convert('buy')">立即兑换</div>
        </div>
        <!--div class="exchange_list exchange_bg_blue">
          <div class="exchange_money_wrapper">4800券币＋25元
                <div class="circle">
                  <div class="circle1">

                  </div>
                  <div class="circle2">

                  </div>
                </div>
          </div>
          <div class="exchange_btn_wrapper">立即兑换</div>

        </div-->
      </div>
      <doGood :thumbCount = "item.thumbCount * 1" :isDoGood = "item.thumbOpenid" :goodID = "item.goodID" :openID="this.openID" :getThumbs="getThumbs" @updataThumbOpenid="updataThumbOpenid" v-if="item.goodID"></doGood>
      <doGoodNum :getThumbs="getThumbs" :goodThumbs='goodThumbs' v-if="item.thumbCount>0&&item.goodID"></doGoodNum>
    </div>
    <discuss :getDiscuss="getDiscuss" :discuss="discuss"></discuss>
    <message v-if="item.goodID" :goodID = "item.goodID" :openID="this.openID" :getDiscuss="getDiscuss" ></message>
    <mt-popup class="copyBox"
    v-model="copyBox"
    position="top" :closeOnClickModal= false :modal= true >
      <div class="copyBoxContainer">
        <strong class="title">恭喜您!!!</strong>
        <p class="greetings">券币兑换成功，请主动添加客服微信号xiaopei116，联系发货事宜！一键复制微信号后，您可以直接去添加好友了。</p>
      <div class="btn_wrapper">
        <button class="one_copy_btn copy_btn"  :data-clipboard-text="clipData" @click="getWebCopy">一键复制</button>
        <button class="close_copy_btn copy_btn" @click="closeModal">关闭</button>
      </div>
      </div>
  </mt-popup>
  </div>

</template>
<script type="text/ecamscript-6">
  import Vue from 'vue'
  import SwiperVue from 'swiper'
  import Clipboard from 'clipboard' //获取粘贴插件
  import 'swiper/dist/css/swiper.min.css'
  import { MessageBox,Popup } from 'mint-ui';
  Vue.component(Popup.name, Popup);
  import DoGood from '@/components/userCenter/mall/doGood'
  import DoGoodNum from '@/components/userCenter/mall/doGoodNum'
  import Discuss from '@/components/userCenter/mall/discuss'
  import Message from '@/components/userCenter/mall/message'
  import {subScore,sendBuyScoreMallGoodTempleteMessage} from "../../../common/js/common.js"
  //Vue.use(MessageBox)
  export default {
    name:"MallItem",
    data(){
      return{
        item:[],
        itemid:72,
        goodID:this.$route.params.id,
        clipData:"xiaopei116",
        copyBox:false,
        goodThumbs:{},
        discuss:[],
        openID:JSON.parse(sessionStorage.userInfo).openId
        //openID:this.$store.state.userInfo.openId

      }
    },
    created () {
    this.login()


    },


    methods:{

      login(){//获取数据
        let url = "api/getGiftInfo.php?goodid="+this.$route.params.id+"&thumbOpenid="+this.openID
        this.$ajax.autoService.
        login(url).then((res)=>{
          this.item = res.data[0]
        })
      },
      convert() {//点击兑换
        //判断是否券币足够
      if ((this.scoreUserInfo.totalScore * 1 - this.scoreUserInfo.usedScore * 1 - this.item.score * 1) > 0) {
        this.$ajax.autoService.
        login("api/getCountBuyScoreMall.php?goodID="+this.goodID+"&openID="+this.openID).then((res)=>{
          console.log(res)
          if((this.item.perMonth*1-res.data*1)>0){
            MessageBox.confirm('是否确定兑换?').then(action => {
              if(action=="confirm"){
                this.$ajax.autoService.
                login("api/buyScoreMallGood.php?goodID="+this.goodID+"&openID="+this.openID+"&score="+this.item.score+"&comment=").then((res)=>{
                  //console.log(this.openID)
                  this.$store.dispatch("cancelScore",{"total":this.scoreUserInfo.totalScore,"userScore":this.item.score*1})
                  //this.item.score = encodeURIComponent(-this.item.score*1)
                  subScore("兑换礼品",this.openID,-this.item.score*1)
                })
                this.copyBox = true
              }

 });
          }
        })
      }
    },
    getWebCopy() {
      var clipboard = new Clipboard('.copy_btn')
      //console.log(2)
       clipboard.on('success', e => {
         this.hasTaoKouLing=true
         this.copyBox = false
         // console.info('Text:', e.text);
         //console.log('复制成功')
         // 释放内存
        clipboard.destroy()

       })
       clipboard.on('error', e => {
         // 不支持复制
         console.log('该浏览器不支持自动复制')
         // 释放内存
         clipboard.destroy()
       })
      },
      closeModal () {
      this.copyBox = false
    },
    getThumbs(doType){
      //console.log(this.goodID)
      this.$ajax.autoService.
      login("api/getGiftThumbs.php?goodid="+this.goodID).then((res)=>{
        this.goodThumbs = res.data
        this.item.thumbCount =this.item.thumbCount*1+doType*1
      })
    },
    updataThumbOpenid(val,num){//触发子组建改变点赞
      this.item.thumbOpenid = val;
      this.item.thumbCount = this.item.thumbCount*1+num
      let goodThumbsTemp = [];
      if(num<0){
        for (let i = 0; i < this.goodThumbs.length; i++) {
            if (this.goodThumbs[i].thumbopenid != this.openID) {
            goodThumbsTemp.unshift(this.goodThumbs[i])
            }
          }
          this.goodThumbs = goodThumbsTemp
      }
    },
    getDiscuss(doType,page,pageSize) {
      this.$ajax.autoService.
      login("api/getGiftDiscuss.php?goodid="+this.goodID+"&page="+page+"&pageSize="+pageSize).then((res)=>{
        console.log("api/getGiftDiscuss.php?goodid="+this.item.goodID+"&page="+page+"&pageSize="+pageSize)
        this.discuss = res.data.map(function (item) {
            item.menuShow = false
            return item
          })
        this.item.discussCount =this.item.discussCount*1+doType*1
      })
    }

    },
    mounted () {

    },
    computed:{
      scoreUserInfo:function(){
        return this.$store.state.scoreUserInfo
      },


    },
    components:{
      'doGood':DoGood,
      'doGoodNum':DoGoodNum,
      'discuss':Discuss,
      'message':Message
    }
  }
</script>
<style lang="stylus">
.m_page
  .item_pic
    width:750px
    height:750px
    display:block
  .item_text
    padding:25px 50px 70px
    width:100%;
    box-sizing:border-box
    background:linear-gradient(to top, rgba(0,0,0,0.5), rgba(0,0,0,0))
    position:absolute
    bottom:0px
    font-size:24px
    color:#fff
    line-height:36px
  .item-swiper-pagination
    width:100%
    height:50px
    left:0px
    bottom:0px
    .swiper-pagination-bullet
      width:75px
      height:7px
      background:#afb0b3
      border-radius:0px
      opacity: 1
      &.swiper-pagination-bullet-active
        background:#ffc335
  .base_info
    background:#fff
    padding:0 30px
    .item_title_wrapper
      padding-top:40px
      .item_title
        font-size:48px
        color:#333
        vertical-align:bottom
        margin-right:10px
      .item_num
        font-size:24px
        color:#686868
    .item_detail
      width:100%
      height:64px
      background:#fff2ec
      line-height:64px
      font-size:24px
      color:#ff6f25
      padding-left:10px
      box-sizing:border-box
      margin-top:35px
    .exchange_wrapper
      padding-top:20px
      .exchange_list
        margin-top:20px
        width:100%
        height:120px
        display:flex
        border-radius:20px
        line-height:120px
        text-align:center
        color:#fff
        &.exchange_bg_orange
           background:linear-gradient(to right, #f80, #f40)
        &.exchange_bg_blue
          background:linear-gradient(to right, #35bfff, #19be63)
        .exchange_money_wrapper
          flex:0 0 440px
          padding-right:20px
          box-sizing:border-box
          font-size:30px
          position:relative
          .circle
            height:120px
            position:absolute
            right:0px
            top:0px
            border-left:1px dotted rgba(255,255,255,.5)
            /*px*/
            .circle1,.circle2
              width:24px
              height:12px
              background:#fff
              position:absolute
              right:-12px
            .circle1
              top:0px
              border-radius:0 0 12px 12px
            .circle2
              border-radius:12px 12px 0 0
              bottom:0px
        .exchange_btn_wrapper
          flex:1
          font-size:36px

.mint-msgbox
  padding-top:30px
  .mint-msgbox-title
    font-size:30px
  .mint-msgbox-message
    font-size:26px
    padding-bottom:15px
  .mint-msgbox-btns
    height:80px
    .mint-msgbox-btn
      height:80px
.mint-popup
  &.copyBox
    width:100%
    height:100%
    background:none
    .copyBoxContainer
      width:500px
      padding:30px 0 0 0
      position:fixed
      left:50%
      top:50%
      z-index:999
      background:#fff
      transform:translate(-50%,-50%)
      border-radius:20px
      overflow:hidden
      .title
        font-size:34px
        color:#f40
        display:block
        text-align:center
      .greetings
        font-size:28px
        color:#333
        text-align:center
        margin-top:10px
        padding:0 30px
      .btn_wrapper
        display:flex
        margin-top:20px
        border-top:1px solid #f0f0f0
        /*px*/
        .close_copy_btn
          flex:1
          height:80px
          line-height:80px
          font-size:30px
          background:none
          border:0px solid #f0f0f0
          border-left:1px solid #f0f0f0
          /*px*/
        .one_copy_btn
          flex:1
          height:80px
          line-height:80px
          font-size:30px
          color:#f40
          border:0px solid #f0f0f0
          background:none



</style>



// WEBPACK FOOTER //
// src/components/userCenter/mall/mallItem.vue